// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__cLPJz","errors":"Errors_errors__3dP-R"};